import React, {useEffect, useLayoutEffect, useState} from "react";
import PropTypes from "prop-types";
import {css} from "@emotion/react";
import {breakpoints} from "~styles/global";
import Button from "~components/blocks/Button";
import {Global} from "@emotion/react";

const JumpLinks = ({className, links, currentLink, onUpdate, oneColumn}) => {
  const {mobile} = breakpoints;
  const [active, setActive] = useState(currentLink ?? null);
  const [smooth, setSmooth] = useState(false);

  const scrollBehaviour = (link) => {
    setActive(link);
    // Had to change how this works to get it to work in Safari, document.qs seems a bit hacky in React bit maybe fine?
    document.querySelector(link).scrollIntoView({behavior: "smooth"});
    // setSmooth(true)
    // setActive(link)
    // window.setTimeout(() => {
    //   document.location.href=link;
    // }, 100)
    // window.setTimeout(() => {
    //   setSmooth(false)
    // }, 800)
  };

  useEffect(() => {
    if (onUpdate && active) {
      onUpdate(active);
    }
  }, [active]);

  useLayoutEffect(() => {
    document.addEventListener("wheel", handleScroll);
    return () => {
      document.removeEventListener("wheel", handleScroll);
    };
  });

  const handleScroll = () => {
    setActive(null);
  };

  return (
    <>
      <Global
        styles={css`
          html {
            /* scroll-behavior: ${smooth ? `smooth` : `auto`}; */
            /* scroll-behavior: smooth; */
          }
        `}
      />
      <div className={className}>
        <h6
          css={css`
            margin-bottom: 20px;
          `}
        >
          Jump to
        </h6>
        <div
          css={css`
            ${mobile} {
              columns: ${oneColumn ? `1` : `2`};
            }
          `}
        >
          {links.map((link) => (
            <button
              className="h5"
              key={link?.id}
              onClick={() => scrollBehaviour(`#${link?.id}`)}
              css={css`
                color: ${active === `#${link?.id}`
                  ? `inherit`
                  : !active
                    ? `inherit`
                    : `var(--grey)`};
                transition: 0.2s color;
                text-align: left;
                display: block;
                margin-bottom: 1px;
                &:hover {
                  color: inherit;
                }
                ${mobile} {
                  margin-bottom: 10px;
                }
              `}
            >
              {link?.title}
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

JumpLinks.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      title: PropTypes.string,
      id: PropTypes.string,
    }),
  ),
  currentLink: PropTypes.string,
  onChange: PropTypes.func,
};

JumpLinks.defaultProps = {
  currentLink: `link1`,
  links: [
    {
      key: `1`,
      title: `Capdell`,
      id: `link1`,
    },
    {
      key: `2`,
      title: `Cattelan Italia`,
      id: `link2`,
    },
    {
      key: `3`,
      title: `CVL`,
      id: `link3`,
    },
    {
      key: `4`,
      title: `Driade`,
      id: `link4`,
    },
    {
      key: `5`,
      title: `eForma`,
      id: `link5`,
    },
    {
      key: `6`,
      title: `Erba`,
      id: `link6`,
    },
    {
      key: `7`,
      title: `Lago`,
      id: `link7`,
    },
    {
      key: `8`,
      title: `Leolux`,
      id: `link8`,
    },
    {
      key: `9`,
      title: `Luceplan`,
      id: `link9`,
    },
    {
      key: `10`,
      title: `MisuraEmme`,
      id: `link10`,
    },
    {
      key: `11`,
      title: `Montis`,
      id: `link11`,
    },
  ],
  onChange: (value) => console.log("value", value),
};

export default JumpLinks;
